import { flowVersion } from "./flowVersion";

const {
  formField: { createNewVersion }
} = flowVersion;

export const initialValues = {
  [createNewVersion.name]: "minor_version"
};
